var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-text',{staticClass:"pb-0"},[_c('v-textarea',_vm._g(_vm._b({attrs:{"label":_vm.label,"placeholder":_vm.placeholder,"rows":_vm.rows,"prepend-inner-icon":_vm.prependInnerIcon,"outlined":"","value":_vm.value}},'v-textarea',_vm.$attrs,false),_vm.inputListeners))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }